import { NgModule } from '@angular/core';
import { V2LService } from './v2l.service';
import { V2LHoverComponent } from './hover/v2l-hover.component';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [V2LHoverComponent],
  exports: [V2LHoverComponent],
  providers: [V2LService]
})
export class V2LModule {
}
